import { capSQLiteSet } from "@capacitor-community/sqlite";
import { CoreoForm } from "../../../types";
import { SyncForm } from "../app-sync.service";
import { AppDatabaseRepo } from "./base.db";

export interface AppDatabaseForm {
  id: number;
  projectId: number;
  parentProjectId: number | null;
  name: string;
  title: string;
  slug: string;
  anonymous: boolean;
  thankyou: string;
  isPrimary: boolean;
  titleAttributeId: number;
  secondaryTitleAttributeId: number;
  color: string;
  visible: boolean;
  allowMemberUpdate: boolean;
  allowOwnRecordDelete: boolean;
  private: boolean;
  sort: number;
  formGroupId: number | null;
  style: string;
  mapSort: number;
  mapVisible: boolean;
  labelAttributeId: number;
  labelCollectionAttributeId: number;
  labelCollectionSourceType: "value" | "key" | "attribute";
  styleAttributeId: number;
  dataEventsScript: string | null;
  dataEventsScriptES5: string | null;
  dataEventsVersion: number | null;
}

export class AppDatabaseFormRepo extends AppDatabaseRepo<AppDatabaseForm, SyncForm, CoreoForm> {

  columns = [
    ['id', 'INTEGER NOT NULL'],
    ['projectId', 'INTEGER NOT NULL'],
    ['name', 'TEXT NOT NULL'],
    ['title', 'TEXT'],
    ['slug', 'TEXT'],
    ['anonymous', 'INTEGER'],
    ['thankyou', 'TEXT'],
    ['isPrimary', 'INTEGER'],
    ['titleAttributeId', 'INTEGER'],
    ['secondaryTitleAttributeId', 'INTEGER'],
    ['color', 'TEXT'],
    ['visible', 'INTEGER'],
    ['allowMemberUpdate', 'INTEGER'],
    ['private', 'INTEGER'],
    ['sort', 'INTEGER'],
    ['formGroupId', 'INTEGER'],
    ['style', 'TEXT'],
    ['mapSort', 'INTEGER'],
    ['mapVisible', 'INTEGER'],
    ['labelAttributeId', 'INTEGER'],
    ['labelCollectionAttributeId', 'INTEGER'],
    ['labelCollectionSourceType', 'TEXT'],
    ['styleAttributeId', 'INTEGER'],
    ['allowOwnRecordDelete', 'INTEGER'],
    ['dataEventsScript', 'TEXT'],
    ['dataEventsScriptES5', 'TEXT'],
    ['dataEventsVersion', 'INTEGER'],
    ['parentProjectId', 'INTEGER']

  ];
  indexes = [
    'CREATE INDEX IF NOT EXISTS idx_forms_projectId ON forms(projectId)'
  ];
  references = [];

  primaryKey = ["id", "projectId"];
  tableName = 'forms';

  public toInsertSet(form: SyncForm): capSQLiteSet[] {
    const columns = this.columns.map(c => c[0]).join(',');
    const values = this.columns.map(() => '?').join(',');
    return [{
      statement: `INSERT OR REPLACE INTO ${this.tableName} (${columns}) VALUES (${values})`,
      values: [
        form.id,
        form.projectId,
        form.name,
        form.title,
        form.slug,
        form.anonymous,
        form.thankyou,
        form.isPrimary,
        form.titleAttributeId,
        form.secondaryTitleAttributeId,
        form.color,
        form.visible,
        form.allowMemberUpdate,
        form.private,
        form.sort,
        form.formGroupId ?? null,
        JSON.stringify(form.style),
        form.mapSort,
        form.mapVisible,
        form.labelAttributeId,
        form.labelCollectionAttributeId,
        form.labelCollectionSourceType,
        form.styleAttributeId,
        form.allowOwnRecordDelete,
        form.dataEventsScript ?? null,
        form.dataEventsScriptES5 ?? null,
        form.dataEventsVersion ?? null,
        form.parentProjectId ?? null
      ]
    }];
  }


  async deserialise(form: AppDatabaseForm): Promise<CoreoForm> {
    return {
      ...form,
      style: JSON.parse(form.style)
    };
  }

}
